import {Theme, createStyles} from '@material-ui/core';
import {StyleRules} from '@material-ui/core/styles';

const bookedTimesOverviewStyles = (theme: Theme): StyleRules =>
	createStyles({
		dayOff: {
			backgroundColor: '#e0e0e0',
		},
		reloadButton: {
			marginLeft: theme.spacing(2),
		},
		filterContainer: {
			display: 'flex',
			alignItems: 'center',
			marginBottom: theme.spacing(2),
		},
		negativeHours: {
			color: '#F00',
		},
	});

export default bookedTimesOverviewStyles;
